import { Theme } from '@mui/material/styles';

/**
 * This is a transition helper for Material UI v4 to v5
 * - MUI v4 theme.spacing(x) used to return numbers (ie. 8)
 * - MUI v5 returns 8px (with unit)
 *
 * @see https://github.com/mui/material-ui/issues/29086
 *      https://stackoverflow.com/questions/69319992/spacing-math-with-theme-spacing-in-mui-v5
 *
 * @todo wait for the issue resolution and replace this util OR consider
 *       extending createTheme to inject a similar function to the them
 */
export const getNumericSpacing = (theme: Theme, value: number) =>
  Number(theme.spacing(value).slice(0, -2));
